export const OPEN_DIALOG_PDF = "[DIALOG_PDF] OPEN";

export function openDialogPdf(data) {
  return {
    type: OPEN_DIALOG_PDF,
    payload: data,
  };
}
